import { fg_busy, fg_positive, fg_warning } from "@clockwise/design-system/tokens";

export type ProposalOptionCardVariant = "conflict" | "sbm" | "no-conflict";
export const COLORS: { [v in ProposalOptionCardVariant]: string } = {
  conflict: fg_warning,
  sbm: fg_busy,
  "no-conflict": fg_positive,
};
